import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Button, Container, Table } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApiCall } from "../../useApiCall";
import "./courses.css";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const getCourses = useApiCall("/courses", "GET");
  const navigate = useNavigate();

  useEffect(() => {
    const abort = new AbortController();
    getCourses(undefined, "", { signal: abort.signal }).then((resp) => {
      if (Array.isArray(resp)) {
        setCourses(resp);
      }
    });
    return () => abort.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid>
      <h2 className="page-header">Εκπαιδευτικό υλικό</h2>

      {courses.length === 0 && (
        <span className="text-muted">
          Δεν υπάρχει διαθέσιμο υλικό&hellip;
        </span>
      )}

      {courses.length > 0 && (
        <Table className="table-centered courses-table" striped hover responsive>
          <thead>
            <tr>
              <td className="course-title-col">Τίτλος</td>
              <td className="col-fit">Κατάσταση</td>
              <td className="col-fit"></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {courses.map((course) => (
              <tr key={course.id}>
                <td className="course-title-col">
                  <span className="course-title">{course.title}</span>
                  {course.description && (
                    <div className="text-muted small">
                      {course.description}
                    </div>
                  )}
                </td>
                <td className="col-fit">
                  {course.completed ? (
                    <Badge className="course-status-badge" color="success">
                      <FontAwesomeIcon icon="check" /> Ολοκληρώθηκε
                    </Badge>
                  ) : (
                    <Badge className="course-status-badge" color="secondary">
                      Εκκρεμεί
                    </Badge>
                  )}
                </td>
                <td className="col-fit course-action-col">
                  <Button
                    color="primary"
                    onClick={() => navigate(`/courses/${course.id}`)}
                  >
                    <FontAwesomeIcon icon="eye" /> Προβολή
                  </Button>
                </td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default Courses;
